<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ilrCJ1/tc-custom/9781449406202.jpg?1707566367707" alt="This image is the cover for the book Women Are from Venus, Men Are Idiots"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Women Are from Venus, Men Are Idiots
      </h1>
      <p class="bookDescription body article font2">
        <p>Inside <i>Women Are from Venus, Men Are Idiots</i>, <i>Close to Home</i> cartoonist John McPherson illustrates what happens when planets--and planetary beings--just don't seem to align. From memorable Thanksgiving TV-carving dinners to disjointed marriage counseling sessions, McPherson culls more than 75 relationship-specific, full-color panels inside this interplanetary ode to coupledom.</p><p>McPherson's mastery in <i>Close to Home</i> is elevating the mundane to the magnificent. The caustic interactions between balding, bespeckled middle-aged men and auburn-haired, beehive-tressed women become achingly funny when sketched by his pen. Appearing in more than 700 newspapers internationally, McPherson's <i>Close to Home</i> is one of the most popular card lines from Recycled Paper Greetings. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John McPherson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d587fea2